import {  useFormErrors } from '../../../utils/utils';

//Отображение времени при добавлении рецепта
// components/TimeInput.jsx
import React from 'react';
import { InputCheckbox, Tooltip } from '..'; 
import { Popup } from '../../organisms';

export const TimeInput = (props) => {
  const { timeKey, label, unitOptions = ['мин', 'час'], order } = props.timeStage;
  const timeValue = props.recipeTimes?.[timeKey] || 0;
  const isActive = timeValue > 0; 
  const [selectedUnit, setSelectedUnit] = React.useState('мин');
  const [showEventList, setShowEventList] = React.useState(false);
  const [localTime, setLocalTime] = React.useState(timeValue);
  const eventRef = React.useRef();
  const [localError, setLocalError] = React.useState('');

  // Синхронизация с props при изменении recipeTimes
  React.useEffect(() => {
    setLocalTime(props.recipeTimes?.[timeKey] || 0);
  }, [props.recipeTimes, timeKey]);
  
  const handleTimeChange = (e) => {
    const value = parseInt(e.target.value) || 0;
    setLocalTime(value); 
     let errorMsg = '';
    if (timeKey === 'basic' && value <= 0) {
      errorMsg = 'Укажите время';
    } else if (value < 3) {
      errorMsg = 'Укажите время больше 2 мин';
    }  
    
    setLocalError(errorMsg);
    props.onTimeChange(timeKey, value, selectedUnit);
  };
  
  // Отображаем локальную ошибку, если есть, иначе из props
  const displayError = localError || props.error?.[timeKey]; 
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked; 
    if (!checked) {
      // Если убрали галочку - обнуляем время
      props.onTimeChange(timeKey, 0, selectedUnit);
      setLocalTime(0);
      setLocalError(timeKey === 'basic' && 'Это поле обязательное для заполнения');
    } else {
      setLocalError('');
      // Если поставили галочку и время было 0 - ставим 3
      if (localTime === 0) {
        props.onTimeChange(timeKey, 3, selectedUnit);
        setLocalTime(3);
      } else {
        props.onTimeChange(timeKey, localTime, selectedUnit);
      }
    }
  };
  
  const handleUnitChange = (unit) => {
    setSelectedUnit(unit);
    props.onUnitChange?.(timeKey, unit);
    setShowEventList(false);
  };
  
  const toggleEventList = () => {
    setShowEventList(!showEventList);
  };
  
  React.useEffect(() => {
    const click = (e) => {
      if (showEventList && eventRef.current && !eventRef.current.contains(e.target) && !e.target.classList.contains('eventtoggle')) {
        setShowEventList(false);
      }
    };
    document.addEventListener("mousedown", click);
    return () => {
      document.removeEventListener("mousedown", click);
    };
  }, [showEventList]);
  
  // Определяем, показывать ли как дополнительное (после basic)
  const isAdditional = timeKey !== 'basic' && order > 3; 
  return (
    <>
      {isAdditional && order === 4 && (
        <legend className="font20EB colorGrey">Дополнительно:</legend>
      )}
      <div className="form__label_time font20Norm colorGrey">
        <div className='form__block_time'>
          <InputCheckbox
            checked={isActive}
            title={label}
            name={timeKey}
            id={timeKey}
            onChange={handleCheckboxChange}
          />
          
          <label className='form__label_time_err'>
            <input
              type="number"
              id={timeKey}
              name={timeKey}
              min='1'
              placeholder='0'
              value={localTime || ''}
              disabled={!isActive}
              className={`form__input_time ${!isActive ? 'input__disabled' : ''} ${props.errors?.[timeKey] && isActive ? 'form__input_error' : ''}`}
              onChange={handleTimeChange}
            />
            <TimeSelector
              onClick={handleUnitChange}
              selectedUnit={selectedUnit}
              unitOptions={unitOptions}
              showEventList={showEventList}
              toggleEventList={toggleEventList}
              eventRef={eventRef}
            />
          </label>
        </div>
        
       {displayError && (
        <span className="form__text_error font14Norm">
          {displayError}
        </span>
      )}
      </div>
    </>
  );
};

// Компонент выбора единиц измерения
const TimeSelector = ({ selectedUnit, unitOptions, showEventList, toggleEventList, eventRef, onClick }) => {
  return (
    <div className='hours__select'>
      <div className='hours__select_visible'>
        <p className='hours__unit' onClick={toggleEventList}>
          {selectedUnit}
        </p>
      </div>
      <Popup isOpen={showEventList} ref={eventRef} type='hours'>
        {unitOptions.map((unit, index) => (
          <span 
            key={index} 
            className="form__span_time font20Norm colorGrey" 
            onClick={() => onClick(unit)}
          >
            {unit}
          </span>
        ))}
      </Popup>
    </div>
  );
};

export default TimeInput;